import script from "./ProductRimsByCar.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductRimsByCar.vue?vue&type=script&setup=true&lang=ts"

import "./ProductRimsByCar.vue?vue&type=style&index=0&id=47f2d614&lang=scss&scoped=true"

import exportComponent from "/srv/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47f2d614"]])

export default __exports__